import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Home from './pages/Home';
import Header from './pages/Header';
import Footer from './components/Footer'; // ✅ Import Footer
import './styles/tailwind.css';
import Login from './pages/Login';
import Signup from './pages/Signup';
import ConfirmSignup from './pages/ConfirmSignup';
import ResetPassword from './pages/ResetPassword';
import UpdatePassword from './pages/UpdatePassword';
import Dashboard from "./pages/Dashboard";
import ProtectedRoute from "./components/ProtectedRoute";
import RedirectIfAuthenticated from "./components/RedirectIfAuthenticated";
import ApiDocsPage from './pages/ApiDocs';
import PricingPage from './pages/Pricing';
import SupportedCountriesPage from './pages/Countires';
import TermsAndConditions from './pages/Terms';
import PrivacyPolicy from './pages/PrivacyPolicy';
import RequestInvoice from './pages/RequestInvoice';
import CookieConsentBanner from './components/CookieConsentBanner';

const App = () => {
  const location = useLocation();
  const hideConsent = ['/privacy', '/terms'].includes(location.pathname);

  return (
    <AuthProvider>
      <div className="bg-gray-100 flex flex-col min-h-screen">
        <Header />

        <main className="flex-grow">
          <Routes>
            <Route element={<RedirectIfAuthenticated />}>
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/" element={<Home />} />
            </Route>

            <Route path="/api-docs" element={<ApiDocsPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/countries" element={<SupportedCountriesPage />} />
            <Route path="/terms" element={<TermsAndConditions />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />

            <Route path="/confirm-signup" element={<ConfirmSignup />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/update-password" element={<UpdatePassword />} />

            <Route element={<ProtectedRoute />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/request-invoice" element={<RequestInvoice />} />
            </Route>
          </Routes>
        </main>

        {!hideConsent && <CookieConsentBanner />}
        <Footer /> {/* ✅ Add Footer here */}
      </div>
    </AuthProvider>
  );
};

export default App;
